import EntityUtils from 'utils/EntityUtils';
import moment from 'moment';
import SettingsUtils from 'utils/SettingsUtils';
import CommonFunctionsUtils from 'utils/CommonFunctionsUtils';
import { DateTime } from 'luxon';
import TimeUtils from 'utils/TimeUtils';

class NotificationUtils {}

export default new NotificationUtils();
